import { render, staticRenderFns } from "./Work-Order.vue?vue&type=template&id=af4b8aa0&"
import script from "./Work-Order.vue?vue&type=script&lang=js&"
export * from "./Work-Order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports